import { render, staticRenderFns } from "./embed-modal.vue?vue&type=template&id=f0882c76&"
import script from "./embed-modal.vue?vue&type=script&lang=js&"
export * from "./embed-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports